<template>
  <van-popup
    v-model="visible"
    position="bottom"
    :close-on-click-overlay="false"
    @click-overlay="close"
    safe-area-inset-bottom
  >
    <img
      src="@/assets/lucky/icon_close.png"
      alt=""
      class="close"
      @click="close"
    />
    <div v-if="data" class="body">
      <div class="goods">
        <img
          :src="data.image"
          alt=""
          class="icon"
          @click="toPreview(data.image)"
        />
        <div class="info">
          <div class="price">
            <span class="rmb">￥</span>
            <span>{{ data.price }}</span>
          </div>
          <span v-if="data.sku" class="spec">商品规格：{{ data.sku }}</span>
        </div>
      </div>
      <div class="block">
        <div>
          <span class="label">奖品描述：</span>
          <span>{{ data.info }}</span>
        </div>
        <div>
          <span class="label">开奖时间：</span>
          <span>{{ data.lottery_time }}</span>
        </div>
      </div>
      <div class="action">
        <span class="title">抽奖券数量</span>
        <van-stepper
          class="stepper"
          :min="1"
          :max="data._canuse"
          :step="1"
          v-model="value"
        />
      </div>
    </div>
    <div class="submit" @click="submit">立即参与</div>
  </van-popup>
</template>

<script>
import { ImagePreview } from "vant";

export default {
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      value: 1,
    };
  },
  watch: {
    data() {
      this.value = 1;
    },
  },
  methods: {
    close() {
      this.$emit("visibleChange", false);
    },
    toPreview(e) {
      ImagePreview({
        images: [e],
      });
    },
    submit() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$api
        .post("activity/member/lucky/member-draw", {
          activity_id: this.data.id,
          num: this.value,
        })
        .then((res) => {
          this.$toast("参与成功");
          this.close();
          this.$emit("reload");
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="less" scoped>
.bg-img {
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.van-popup:extend(.bg-img) {
  height: 80vh;
  border-radius: 1.2rem 1.2rem 0 0;
  overflow: hidden;
  background-image: linear-gradient(
    180deg,
    #fef9f3 0%,
    #fcf2ee 15%,
    #ffffff 100%
  );
  background-size: 100% 16.1rem;
  box-sizing: border-box;
  padding: 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .close {
    position: absolute;
    width: 2rem;
    height: 2rem;
    top: 1.2rem;
    right: 1.2rem;
  }
}

.body {
  flex: 1;

  .goods {
    display: flex;

    .icon {
      flex: 0 0 10rem;
      height: 10rem;
      border: 0.2rem solid #fff;
      border-radius: 0.4rem;
      margin-right: 1.1rem;
    }

    .info {
      display: flex;
      flex-direction: column;

      .price {
        font-size: 2rem;
        color: #f9591b;
        font-weight: 700;
        margin-top: 1rem;

        .rmb {
          font-size: 1.4rem;
        }
      }

      .spec {
        color: #999999;
        font-size: 1.3rem;
        margin-top: 1rem;
      }
    }
  }

  .block {
    background: #f5f6f7;
    padding: 1.2rem 1.4rem;
    margin-top: 2rem;

    & > div:not(:first-of-type) {
      margin-top: 0.8rem;
    }

    .label {
      color: #666666;
    }
  }

  .action {
    margin-top: 2.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-weight: 700;
    }

    /deep/ .stepper {
      // width: 9.4rem;
      height: 2.3rem;
      border-radius: 1.2rem;
      border: 0.1rem solid #f5f6f7;
      white-space: nowrap;

      .van-stepper__minus,
      .van-stepper__plus {
        height: 2.3rem;
        background-color: transparent;
      }

      .van-stepper__input {
        width: 3.3rem;
        height: 2.3rem;
        background: #f5f6f7;
      }

      .van-stepper__minus::before,
      .van-stepper__plus::before {
        width: 1.3rem;
        height: 0.2rem;
      }
      .van-stepper__plus::after {
        height: 1.3rem;
        width: 0.2rem;
      }
    }
  }
}

.submit {
  background: linear-gradient(270deg, #f41a3c 0%, #fc740c 100%);
  height: 4.2rem;
  border-radius: 2.1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.6rem;
  color: #fff;
  font-weight: 700;
}
</style>
